import React, { Component } from 'react';
import SendTransaction from './send_transaction.js';
import { Link } from 'react-router-dom'

export default class Withdraw extends Component {

  render() {

    var page = this.props.name;
    const data = this.props.data;
    const sendtransaction = this.props.sendtransaction;
    var suspended = false;

    if ((page === "cobinhood" && window.cobinhood_allow === "False") ||
      (page === "cybermiles" && window.cybermiles_allow === "False") ||
      (page === "wandx" && window.wandx_allow === "False") ||
      (page === "xyo" && window.xyo_allow === "False") ||
      (page === "fuzex" && window.fuzex_allow === "False") ||
      (page === "nbr" && window.nbr_allow === "False") ||
      (page === "ncash" && window.ncash_allow === "False") ||
      (page === "singularitynet" && window.singularitynet_allow === "False") ||
      (page === "autonio" && window.autonio_allow === "False") ||
      (page === "credits" && window.credits_allow === "False") ||
      (page === "stacs" && window.stacs_allow === "False") ||
      (page === "orbs" && window.orbs_allow === "False") ||
      (page === "essentia" && window.essentia_allow === "False")||
      (page === "incodium" && window.incodium_allow === "False")||
      (page === "moneynet" && window.moneynet_allow === "False"))
    {
      suspended = true;
    }

    if (suspended) {
    return (
      <div class="row">
          <div class="col-lg-12 col-md-12">
              <div class="card-box">
              <div>Withdraw Temporarily Suspended</div>
          </div>
        </div>
      </div>
    );
    } else {
    return (
      <div class="row">
          <div class="col-lg-12 col-md-12">
              <div class="card-box">
                  <h4 class="header-title m-t-0 m-b-30">{data.withdraw}</h4>

                  <div class="widget-box-2">
                      <div class="widget-detail-2">
                          <h4 class="text-left">{data.daoTokenisUtilityToken}


                          <Link to={{ pathname:'/dashboard/notification'}}>{data.learnMore}</Link>

                          </h4>
                          <h4 class="text-left">{data.withdrawDeductsDao} </h4>
                          <div class="m-t-20"></div>

                          <div class="m-t-20"></div>
                          <button class="btn btn-green w-md" data-toggle="modal" data-target="#con-close-modal">
                              {data.withdraw}
                          </button>
                      </div>
                  </div>
              </div>
          </div>

          <SendTransaction name={page} withdraw="True" data={sendtransaction}/>
      </div>
    );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/withdraw.js